import * as React from 'react';
import './styles.scss';
import ControlStar from '../ControlStar';

export interface IControlStarsProps {
    /* Label */
    label: string;
    /* Allow zero */
    allowZero: boolean;
    /* Required */
    required: boolean;
    /* Range of the score */
    maxScore: number;
    /** Current value */
    score: number;
    /** Handle change */
    setScore: (id) => void;
}

const ControlStars: React.FunctionComponent<IControlStarsProps> = (props) => {
    return (
        <fieldset>
            <div className="radio-group">
                <legend>{props.label} {props.required && (<span className="text-intent-danger">*</span>)}</legend>
                <div className="form-control-stars">
                    { props.allowZero && (
                        <ControlStar value={0} checked={props.score===0} setScore={props.setScore}/>
                    )}
                    {[...Array(props.maxScore)].map((x, i) => <ControlStar key={i}  checked={props.score===i+1}  value={i+1} setScore={props.setScore}/>)}
                </div>
            </div>
        </fieldset>
    );
};

ControlStars.displayName = 'ControlStars';

export default ControlStars;
